import { ImagePicker, List } from "antd-mobile";
import axios from "axios";
import React, { forwardRef, useCallback, useState } from "react";
import { useUpdateEffect } from "react-use";
import instance from "../../util/axios";

interface SelectItemProps {
  dictionary: string;
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
  placeholder: string;
  width: string;
  children?: any;
}

export default forwardRef(
  ({
    dictionary,
    value,
    onChange,
    disabled,
    placeholder,
    width,
    children,
  }: SelectItemProps) => {
    let isHttps = "https:" === document.location.protocol ? true : false;
    const [filesList, setFilesList] = useState<
      {
        url: string;
        uuid: string;
      }[]
    >([]);
    const imageOnChange = useCallback(
      async (files: any[]) => {
        files.forEach(async (picture: any, index) => {
          if (picture.uuid) return; //该照片已上传
          //获得配置
          const resp = await instance.post<any>(
            `/oa/common/attachment/uploadOSSConfNoCrossDomain?fileName=${picture.file.name}&category=vsheet&fileSize=${picture.file.size}&isHttps=false`
          );
          if (resp.data.Status !== "1") return;
          let formData = new FormData();
          formData.append("key", resp.data.Data.dir);
          formData.append("policy", resp.data.Data.policy);
          formData.append("OSSAccessKeyId", resp.data.Data.accessid);
          formData.append("success_action_status", "200");
          formData.append("signature", resp.data.Data.signature);
          formData.append("callback", resp.data.Data.callback);
          formData.append("category", "vsheet");
          formData.append("id", "WU_FILE_0");
          formData.append("type", "application/x-msdownload");
          formData.append("file", picture.file);
          //上传图片
          const respForImage = await axios.post<any>(
            "http://tianyiyuncom.oss-cn-beijing.aliyuncs.com",
            formData
          );
          if (respForImage.data.Status !== "1") return;
          //获取图片链接
          const DownloadOSSFileUrl = await instance.get<any>(
            `/oa/common/attachment/getDownloadOSSFileUrl?ids=${respForImage.data.Data.uuid}&isHttps=${isHttps}`
          );
          if (DownloadOSSFileUrl.data.Status === "1") {
            setFilesList((prevState) => {
              return [
                ...prevState,
                {
                  url: DownloadOSSFileUrl.data.Data[0],
                  uuid: respForImage.data.Data.uuid,
                  index: index,
                },
              ];
            });
          }
        });
      },
      [isHttps]
    );

    useUpdateEffect(() => {
      onChange(filesList.map((item) => item.uuid).join(","));
    }, [filesList]);
    return (
      <>
        <div style={{ fontSize: 15, marginLeft: 15, paddingTop: 15 }}>
          {children}
        </div>
        <ImagePicker
          style={{ width: width }}
          files={filesList}
          multiple={true}
          accept="image/gif,image/jpeg,image/jpg,image/png"
          onChange={(files, operationType, deleteIndex) => {
            if (files && operationType === "add") imageOnChange(files);
            if (deleteIndex !== undefined) {
              setFilesList((prevState) => {
                const cloned = [...prevState];
                cloned.splice(deleteIndex, 1);
                return cloned;
              });
            }
          }}></ImagePicker>
      </>
    );
  }
);
